import api from './api';

export const getCategoriesApi = (params) => api().get('/consultant-categories', { params });
export const addNewCategoryApi = (data) => api().post('/consultant-categories', data);
export const deleteCategoriesApi = (params) => api().delete('/consultant-categories', { params });
export const updateCategoriesApi = (params) => api().put(`/consultant-categories/${params.id}`, params.values);
